export enum UpFlowComponentFlowType {
	LEARN_MORE = 'learn-more',
	UPGRADE = 'upgrade',
	REQUEST_UPGRADE = 'request-upgrade',
	REQUEST_LEARN_MORE = 'request-learn-more',
}
